export default __webpack_public_path__ + "static/media/onboarding-logo.b2247dc5.png";